import { useState } from 'react';
import { CheckTransaction } from '@/api/geovera/specialty-check/check-transactions';
import { Button } from '@/components/ui/button';
import {
	Sheet,
	SheetContent,
	SheetHeader,
	SheetTitle,
} from '@/components/ui/sheet';
import { format } from 'date-fns';
import { Eye, EyeOff } from 'lucide-react';

export const CheckTransactionDetails = ({
	transaction,
}: {
	transaction: CheckTransaction;
}) => {
	const [open, setOpen] = useState(false);

	return (
		<div>
			<Button
				disabled={!transaction.error}
				variant="ghost"
				size="icon"
				className="h-8 w-8"
				onClick={() => setOpen(true)}
			>
				{!transaction.error ? (
					<EyeOff className="h-4 w-4" />
				) : (
					<Eye className="h-4 w-4" />
				)}
			</Button>

			<Sheet open={open} onOpenChange={setOpen}>
				<SheetContent>
					<SheetHeader>
						<SheetTitle>Audit Details</SheetTitle>
					</SheetHeader>
					<div className="mt-6 space-y-6">
						<div className="grid gap-4">
							<div>
								<div className="text-sm">
									Policy #: {transaction.policyNumber || 'No policy number'}
								</div>
							</div>

							<div>
								<div className="text-sm">
									Check #: {transaction.checkNumber || 'No check number'}
								</div>
							</div>

							<div>
								<div className="text-sm">
									Invoice Date:{' '}
									{transaction.invoiceDate
										? format(new Date(transaction.invoiceDate), 'MM/dd/yyyy')
										: 'No invoice date'}
								</div>
							</div>

							<div>
								<div className="text-sm">
									Insured Name: {transaction.insuredName1 || 'No insured name'}
								</div>
							</div>

							<div>
								<div className="text-sm">
									Insured Name 2: {transaction.insuredName2 || 'No insured name 2'}
								</div>
							</div>

							<div>
								<div className="text-sm">
									Street: {transaction.street || 'No street address'}
								</div>
							</div>

							<div className="text-sm">City: {transaction.city || 'No city'}</div>

							<div className="text-sm">State: {transaction.state || 'No state'}</div>

							<div className="text-sm">Zip: {transaction.zip || 'No zip code'}</div>

							<div>
								<div className="text-sm">
									Amount:{' '}
									{new Intl.NumberFormat('en-US', {
										style: 'currency',
										currency: 'USD',
									}).format(transaction.checkAmount) || 'No amount'}
								</div>
							</div>

							<div className="text-sm">
								Reason: {transaction.reason || 'No reason'}
							</div>

							<div className="text-sm">
								Is Uploaded: {transaction.isUploaded ? 'Yes' : 'No'}
							</div>

							<div>
								<label className="text-sm font-medium">Error</label>
								<div className="text-sm">{transaction.error}</div>
							</div>
						</div>
					</div>
				</SheetContent>
			</Sheet>
		</div>
	);
};
